import { useMemo } from 'react';
import getMeta from '@atlassian/jira-get-meta';

export const useCustomLogo = () => useMemo(() => getMeta('ajs-lf-top-adg3-logourl'), []);
